import { AddPaymentMethodRouteModal } from 'features/payment/account';

export default function AddCard() {
  return <AddPaymentMethodRouteModal />;
}
